<template>
  <b-row class="pt-2">
    <b-col md="4">
      <b-form-group
        :label="$t('Dc Type')"
        label-for="dc_type"
      >
        <v-select
          id="dc_type"
          v-model="examCheck.apply_doc__dc_type"
          :reduce="(option) => option.id"
          :options="dcTypes"
          :get-option-label="(option) => $langName(option.name)"
          :placeholder="$t('All')"
        />
      </b-form-group>
    </b-col>
    <b-col md="4">
      <b-form-group
        :label="$t('Course')"
        label-for="course"
      >
        <b-form-input
          id="course"
          v-model="examCheck.apply_doc__course"
          :placeholder="$t('Course')"
        />
      </b-form-group>
    </b-col>
    <b-col
      md="4"
    >
      <b-form-group
        :label="$t('Status')"
        label-for="status"
      >
        <v-select
          id="status"
          v-model="examCheck.status"
          :reduce="(option) => option.id"
          :options="additionalExamCheckStatus"
          :get-option-label="(option) => $langName(option)"
          :placeholder="$t('All')"
        />
      </b-form-group>
    </b-col>
    <b-col md="12">
      <div class="d-flex">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-2"
          @click="filter"
        >
          {{ $t('Search') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="clear"
        >
          {{ $t('Clear') }}
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
import {
  BRow, BCol, BFormGroup, BButton,
  BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'FilterComponent',
  components: {
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      examCheck: {},
    }
  },
  computed: {
    dcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
    directions() {
      return this.$store.state.staticModule.directionList
    },
    periods() {
      return this.$store.state.staticModule.periodList
    },
    additionalExamCheckStatus() {
      return this.$store.state.staticModule.additionalExamCheckStatus
    },
  },
  methods: {
    filter() {
      this.$emit('refetchTable', this.examCheck)
    },
    clear() {
      this.examCheck = {
        apply_doc__dc_type: null,
        apply_doc__course: null,
        status: null,
      }
      this.$emit('refetchTable', this.examCheck)
    },
    selectDirections(id) {
      if (id) {
        this.$store.dispatch('staticModule/directionList', { org_id: id })
      } else {
        this.$store.commit('staticModule/SET_DIRECTION_LIST', [])
      }
    },
  },
}
</script>

<style scoped>

</style>
